import { Injectable } from "@angular/core";
import tinycolor from "tinycolor2";


const MinContrastRatio = 3;

@Injectable({
    providedIn: 'root'
})
export class ColorCalculateService {
    factorValue = {};

    _getCalculateColor(backgroundColor: string, foregroundColor: string): string {
        const readability = tinycolor.readability(backgroundColor, foregroundColor);
        if (readability < MinContrastRatio) {
            const darkenPercentage = ((1 / (MinContrastRatio - readability)) - 1) * 100;
            if (darkenPercentage < -10) {
                const logDarkenPercentage = this.expDecrease(darkenPercentage, 50);
                return tinycolor(foregroundColor)
                    .darken(logDarkenPercentage).toHexString();
            }
        }
        return foregroundColor;
    }
    getFactor = (value: number, memo: { [key: string]: number }): number => {
        memo = memo || {}

        if (memo[value]) return memo[value]

        return memo[value] = value / Math.exp(value / 8);
    }
    expDecrease(x: number, maxValue: number): number {
        return this.expDecreaseByFactor(x / 8.0, this.getFactor(maxValue, this.factorValue));
    }

    expDecreaseByFactor(x: number, factor: number): number {
        return Math.exp(-x) * factor;
    }
}
